/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Ios_Learn_MoreInputs */



/**
* | output |
* | --- |
* | "Installation help" |
*
* @param {Notifications_Ios_Learn_MoreInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const notifications_ios_learn_more = /** @type {((inputs?: Notifications_Ios_Learn_MoreInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Ios_Learn_MoreInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aide à l’installation")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ayuda para la instalación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ajuda para instalação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Guida all’installazione")
	return /** @type {LocalizedString} */ ("Installation help")
});